import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "demand",
  "use": "demand-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol viewBox=\"0 0 12 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"demand\"><title>Group 3</title><path d=\"M10.96 1.72a1.08 1.08 0 0 0-1.245.886A10.848 10.848 0 0 1 8.14 6.66a2.939 2.939 0 0 0-2.21-1.006c-.877 0-1.667.392-2.207 1.006a10.838 10.838 0 0 1-1.577-4.054 1.08 1.08 0 1 0-2.13.359 13.04 13.04 0 0 0 2.969 6.307v1.08a2.955 2.955 0 0 0 2.946 2.947 2.955 2.955 0 0 0 2.947-2.947v-1.08a13.047 13.047 0 0 0 2.968-6.308 1.08 1.08 0 0 0-.885-1.244m-7.5.75a2.47 2.47 0 1 1 4.94 0 2.47 2.47 0 0 1-4.94 0\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/demand.svg
// module id = 517
// module chunks = 0